class BrokenBlueprintDropCountdown {
  constructor(element) {
    this.element = element;
    this.target = new Date(element.dataset.dropDate || '').getTime();
    this.days = element.querySelector('[data-bb-days]');
    this.hours = element.querySelector('[data-bb-hours]');
    this.minutes = element.querySelector('[data-bb-minutes]');
    this.seconds = element.querySelector('[data-bb-seconds]');
    this.dateLabel = element.querySelector('[data-bb-drop-date]');
    this.timer = null;
  }

  start() {
    if (!Number.isFinite(this.target)) return;
    clearInterval(this.timer);
    this.timer = window.setInterval(() => this.update(), 1_000);
    this.update();
  }

  update() {
    if (!this.element.isConnected) { clearInterval(this.timer); brokenBlueprintCountdowns.delete(this.element); delete this.element.dataset.bbCountdownReady; return; }
    const remaining = Math.max(0, this.target - Date.now());
    const days = Math.floor(remaining / 86_400_000);
    const hours = Math.floor((remaining % 86_400_000) / 3_600_000);
    const minutes = Math.floor((remaining % 3_600_000) / 60_000);
    const seconds = Math.floor((remaining % 60_000) / 1_000);

    if (this.days && this.days.textContent !== String(days).padStart(2, '0')) this.days.textContent = String(days).padStart(2, '0');
    if (this.hours && this.hours.textContent !== String(hours).padStart(2, '0')) this.hours.textContent = String(hours).padStart(2, '0');
    if (this.minutes && this.minutes.textContent !== String(minutes).padStart(2, '0')) this.minutes.textContent = String(minutes).padStart(2, '0');
    if (this.seconds && this.seconds.textContent !== String(seconds).padStart(2, '0')) this.seconds.textContent = String(seconds).padStart(2, '0');

    if (remaining === 0) {
      if (this.dateLabel) this.dateLabel.textContent = 'DROP LIVE';
      if (this.timer) window.clearInterval(this.timer);
    }
  }
}

const brokenBlueprintProductMobile = window.matchMedia('(max-width: 749px)');
const brokenBlueprintProductOrigins = new WeakMap();
let brokenBlueprintProductLayoutListening = false;

const rememberBrokenBlueprintProductPosition = (element) => {
  if (!element || brokenBlueprintProductOrigins.has(element)) return;
  brokenBlueprintProductOrigins.set(element, {
    parent: element.parentNode,
    nextSibling: element.nextSibling,
  });
};

const restoreBrokenBlueprintProductPosition = (element) => {
  const origin = brokenBlueprintProductOrigins.get(element);
  if (!element || !origin?.parent?.isConnected) return;
  origin.parent.insertBefore(element, origin.nextSibling?.isConnected ? origin.nextSibling : null);
};

const syncBrokenBlueprintProductLayout = (root = document) => {
  const scope = root.matches?.('[data-product-grid-content]') ? root : root.querySelector?.('[data-product-grid-content]');
  if (!scope) return;

  const detailsContent = scope.querySelector('.product-details > .group-block > .group-block-content');
  const variantPicker = scope.querySelector('variant-picker');
  const sizeGuide = scope.querySelector('.bb-product-size-guide');
  const sizeFieldset = scope.querySelector('.variant-option[data-bb-option="size"]');
  const sizeLegend = sizeFieldset?.querySelector('legend');

  rememberBrokenBlueprintProductPosition(sizeGuide);

  if (brokenBlueprintProductMobile.matches) {
    if (sizeFieldset && sizeGuide) sizeFieldset.insertBefore(sizeGuide, sizeLegend?.nextSibling || sizeFieldset.firstChild);
  } else {
    restoreBrokenBlueprintProductPosition(sizeGuide);
  }

  if (!brokenBlueprintProductLayoutListening) {
    brokenBlueprintProductLayoutListening = true;
    const resync = () => document.querySelectorAll('[data-product-grid-content]').forEach(syncBrokenBlueprintProductLayout);
    if (brokenBlueprintProductMobile.addEventListener) brokenBlueprintProductMobile.addEventListener('change', resync);
    else brokenBlueprintProductMobile.addListener(resync);
  }
};

const brokenBlueprintCountdowns = new Map();
const initializeBrokenBlueprintProduct = (root = document) => {
  syncBrokenBlueprintProductLayout(root);

  root.querySelectorAll('[data-bb-drop-countdown]').forEach((element) => {
    if (element.dataset.bbCountdownReady === 'true') return;
    element.dataset.bbCountdownReady = 'true';
    const countdown = new BrokenBlueprintDropCountdown(element);
    brokenBlueprintCountdowns.set(element, countdown);
    countdown.start();
  });

};

document.addEventListener('DOMContentLoaded', () => initializeBrokenBlueprintProduct());
document.addEventListener('shopify:section:load', (event) => initializeBrokenBlueprintProduct(event.target));

document.addEventListener('shopify:section:unload', event => {
  for (const [element, countdown] of brokenBlueprintCountdowns) {
    if (event.target.contains(element)) { clearInterval(countdown.timer); brokenBlueprintCountdowns.delete(element); delete element.dataset.bbCountdownReady; }
  }
});
